import React from 'react';
import { Route, Switch } from 'react-router-dom';

import Push from './components/push/push';
import AuthorizedPaths from './routes/AuthorizedPaths';
import UnAuthorizedPaths from './routes/UnAuthorizedPaths';
import { BASE_AUTH_PATH } from './constants';
import { useSelector } from 'hooks/redux';
import { Loader } from '@ru-digital-assets/ui-component';
import RestoreKeyPage from 'pages/RestoreKeyPage';
import './app.scss';

import { version } from '../package.json';

console.log('Version: ', version);

const App = () => {
  const showLoader = useSelector((s) => s.loader.showLoader);

  return (
    <div className="wrapper">
      {showLoader && (
        <div className="app__loader">
          <Loader />
        </div>
      )}
      <Switch>
        <Route path="/restore-key" exact component={RestoreKeyPage} />
        <Route path={BASE_AUTH_PATH} component={UnAuthorizedPaths} />
        <Route path="/" component={AuthorizedPaths} />
      </Switch>
      <Push />
    </div>
  );
};

export default App;
